// extracted by mini-css-extract-plugin
export default {"centered":"_2iAYQ","unsubscribe-width":"MAJKA","unsubscribeWidth":"MAJKA"};